import z from "zod";

export const contactSchema = z.object({
  name: z
    .string()
    .min(1, { message: "Name is required" })
    .max(50, { message: "Name must be less than 50 characters" }),
  email: z
    .string()
    .email({ message: "Invalid email" })
    .min(1, { message: "Email is required" }),
  subject: z
    .string()
    .min(1, { message: "Subject is required" })
    .max(50, { message: "Subject must be less than 50 characters" }),
  message: z
    .string()
    .min(1, { message: "Message is required" })
    .min(10, { message: "Message must be at least 10 characters" })
    .max(400, { message: "Message must be less than 400 characters" }),
});

export type TContactFormData = z.infer<typeof contactSchema>;
